var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5352 13H30.6229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5352 17H30.6229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5352 21H30.6229",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 25H30.6217",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3116 16.4518C16.0373 17.5429 15.4593 18.5356 14.6434 19.3168C13.8275 20.0979 12.8066 20.6362 11.6971 20.87C10.5876 21.1039 9.43416 21.0241 8.36823 20.6396C7.30229 20.2551 6.36678 19.5815 5.66835 18.6954C4.96992 17.8094 4.53667 16.7467 4.41799 15.6285C4.29931 14.5102 4.49999 13.3814 4.99713 12.3707C5.49427 11.36 6.26788 10.5081 7.22976 9.91214C8.19165 9.31618 9.3031 9.00012 10.4374 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4385 14.3096L10.4316 20.9863",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.473 6.5C15.1418 6.5 15.7833 6.76339 16.2562 7.23223C16.7292 7.70107 16.9949 8.33696 16.9949 9C16.9949 9.66304 16.7292 10.2989 16.2562 10.7678C15.7833 11.2366 15.1418 11.5 14.473 11.5L6.40279 6.5C5.80308 6.5001 5.22302 6.71201 4.76668 7.09773C4.31033 7.48345 4.00755 8.01773 3.91265 8.60474C3.81775 9.19175 3.93694 9.79307 4.24884 10.3008C4.56074 10.8086 5.04494 11.1896 5.61459 11.3755",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScript);
export default __webpack_public_path__ + "static/media/icon-script.7f299d8be29f216a9d33350afe82c4ed.svg";
export { ForwardRef as ReactComponent };